import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

const Highcharts = require('highcharts');

declare var global: any;
const Color = global.Color;

@Component({
  selector: 'app-pie-chart',
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss']
})
export class PieChartComponent implements OnChanges {

  @Input() names: Array<string>;
  @Input() counts: Array<number>;
  @Input() searchKeyword: string;
  @Input() dateInput: any;
  @Input() displayDateInput: string;
  @Input() height: any;
  @Input() legendOption: any;
  @Input() bgColor: string;
  @Input() chartTitle: string;
  @Input() detailTitle: string;
  @Input() dataEmpty: boolean;
  @Input() chartWidth: number;
  @Input() marginTop: number;
  @Input() legendY: number;
  @Input() chartName: string;
  @Input() verticalAlign: string;
  @Input() maxHeight: number;
  @Input() textColor : string;

  public chartOptions: any;
  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    // // //Lucnt Comment//console.log('vào ngOnChanges');
    if (this.names !== undefined && this.counts !== undefined) {
      this.createChart();
    }
  }

  private capitalizeName(name) {
    return name.replace(/\b(\w)/g, s => s.toUpperCase());
  }

  public createChart() {
    const series = [{
      name: 'Số lượng',
      colorByPoint: true,
      data: []
    }];
    let index = 0;
    for (const name of this.names) {
      const temp = { name: name, y: this.counts[index] };
      series[0].data.push(temp);
      index += 1;
    }

    this.chartOptions = {
      title: {
        text: ''
      },
      chart: {
        plotBackgroundColor: null,
        backgroundColor: this.bgColor || null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        marginTop: this.marginTop,
        width: this.chartWidth || 300
        // style: {
        //   color: this.textColor || 'white'
        // }
      },
      plotOptions: {
        pie: {
          allowPointSelect: false,
          cursor: 'pointer',//todo          
          dataLabels: {
            // distance: 0, // -50
            enabled: true,
            // format: '<span style="font-weight: normal">{point.name}</span>: {point.y} ' + this.detailTitle,
            // format: '<span style="">{point.percentage:.2f}</span> %',
            formatter: function () {
              if (this.y > 0) {
                // return this.point.name + ': ' + Highcharts.numberFormat(this.point.percentage, 1) + ' %'
                return Highcharts.numberFormat(this.point.percentage, 2) + '%';
              }
            },
            style: {
              color: this.textColor || (Highcharts.theme && Highcharts.theme.contrastTextColor) ||  'white',
              // fontFamily: 'Arial, Helvetica, Verdana, sans-serif;'
            }
          },
          showInLegend: true,
          // size: '100%'
        }
      },
      tooltip: {
        shared: true,
        formatter: function () {
          // return this.series.name + ':<b>' + this.y + '</b> ' + '<br>Tỷ lệ: <b>' + Highcharts.numberFormat(this.percentage, 2) + '%</b> ';
          // return this.series.name + ':<b>' + this.y + '</b> ';
          return this.key + ':<b>' + this.y + '</b> ';
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: true
      },
      legend: {
        maxHeight: this.maxHeight || 70,
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: this.verticalAlign || 'top',
        x: 0,
        y: this.legendY || 0,
        // y: 100,
        floating: true,
        backgroundColor: this.bgColor || (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || '#FFFFFF',
        itemStyle: {
          fontWeight: 'normal',
          color: this.textColor || '#6495ED'
        },
        itemHoverStyle: {
          color: 'green'
        },
        navigation: {
          activeColor: '#3E576F',
          animation: true,
          arrowSize: 12,
          inactiveColor: '#CCC',
          style: {
            fontWeight: 'bold',
            color: '#6495ED',
            fontSize: '14px'
          }
        }
      },
      colors: this.createArrColor(this.chartName),
      series: series
    };
  }

  public createArrColor(chartName){
    var arr = Array();
    if(chartName == "chan_dung_tac_gia"){
      // Chân dung tác giả
      arr.push(Color('#66ccff').alpha(0.8).rgbString());
      arr.push(Color('#ff3333').alpha(0.8).rgbString());
      arr.push(Color('#009933').alpha(0.8).rgbString());
      arr.push(Color('#cc0066').alpha(0.8).rgbString());
    }else if(chartName == "chu_de_thao_luan"){
      // Chủ đề thảo luận
      arr.push(Color('#037110').alpha(0.8).rgbString());
      arr.push(Color('#bcc0c3').alpha(0.8).rgbString());
      arr.push(Color('#1877f2').alpha(0.8).rgbString());
      arr.push(Color('#f74459').alpha(0.8).rgbString());
      arr.push(Color('#66ff33').alpha(0.8).rgbString());

      arr.push(Color('#33cc00').alpha(0.8).rgbString());
      arr.push(Color('#66ffcc').alpha(0.8).rgbString());
      arr.push(Color('#990000').alpha(0.8).rgbString());
      arr.push(Color('#ccddff').alpha(0.8).rgbString());
      arr.push(Color('#ff3399').alpha(0.8).rgbString());

      arr.push(Color('#99004d').alpha(0.8).rgbString());
      arr.push(Color('#ffe6e6').alpha(0.8).rgbString());
      arr.push(Color('#ff66ff').alpha(0.8).rgbString());
      arr.push(Color('#b300b3').alpha(0.8).rgbString());
      arr.push(Color('#8080ff').alpha(0.8).rgbString());

      arr.push(Color('#00ff00').alpha(0.8).rgbString());
      arr.push(Color('#66ccff').alpha(0.8).rgbString());
      arr.push(Color('#ff3333').alpha(0.8).rgbString());
      arr.push(Color('#009933').alpha(0.8).rgbString());
      arr.push(Color('#cc0066').alpha(0.8).rgbString());
    }else if(chartName == "nguon_thao_luan"){
      // Nguồn thảo luận
      arr.push(Color('#FF6384').alpha(0.8).rgbString());
      arr.push(Color('#36A2EB').alpha(0.8).rgbString());
      arr.push(Color('#FFCE56').alpha(0.8).rgbString());
      arr.push(Color('#4BC0C0').alpha(0.8).rgbString());
      arr.push(Color('#9966FF').alpha(0.8).rgbString());
      arr.push(Color('#9966FF').alpha(0.8).rgbString());
      arr.push(Color('#4D4D4D').alpha(0.8).rgbString());
      arr.push(Color('#00FF00').alpha(0.8).rgbString());
    }
    return arr;
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/_custom/pie-chart/pie-chart.component.ts